import React, { Suspense, lazy } from 'react'
import { AppProvider } from '@!/providers'
const StaticPage = lazy(() => import('@!/StaticPage/containers/StaticPage'))
import { useAppSettings } from '@!/Hooks/useAppSettings'

const StaticPageApp = (props) => {
  const jotaiStore = useAppSettings({ isSaveLastUrl: false })

  return (
    <AppProvider jotaiStore={jotaiStore}>
      <Suspense fallback={null}>
        <StaticPage pageType={props.page_type} params={props.params} />
      </Suspense>
    </AppProvider>
  )
}

export default StaticPageApp
